import { all, call, put, takeEvery, select } from 'redux-saga/effects'

import { actions as translationActions } from 'src/features/fw-ai/children/translation/TranslationSlice'
import { getTranslationList } from 'src/features/fw-ai/children/translation/TranslationSelector'
import { isEmpty, supportBCP } from 'src/utils'
import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import SessionService from 'src/services/SessionService'
import { actions as bootstrapActions } from 'src/features/bootstrap/BootstrapSlice'
import siteConfig from 'src/config/fw-ai/site.config.json'

const { configuration } = siteConfig

/**
 * @param services
 * function that sets page language hierarchy for authenticated users
 * 1. check for supported language set at profile level
 * 2. if it set at the browser and supported
 * 3. if user profile country is set to accepted languageCode
 * 4. set to fallbackLng
 */
function* translationRequest(services) {
  const {
    localization: { fallbackLng, countryLang, debug = false }
  } = configuration
  try {
    const browserLang = navigator.language
    const state = new SessionService().getFromCache('state', '')
    const profileCountryCode = state?.userInfo?.countryCode || 'US'
    const profileLanguageCode = supportBCP(
      state?.userInfo?.languageCode || 'en'
    )
    const TranslationService = services('TranslationService')

    // RETRIEVE RESOURCES
    let resources = yield select(getTranslationList())
    if (isEmpty(resources)) {
      try {
        resources = yield call([TranslationService, 'fetchTranslation'])
      } catch (e) {
        console.error(e)
      }
    }

    let languageCode
    if (
      !isEmpty(profileLanguageCode) &&
      Object.keys(resources).includes(profileLanguageCode)
    ) {
      languageCode = profileLanguageCode
    } else if (
      !isEmpty(browserLang) &&
      Object.keys(resources).includes(browserLang)
    ) {
      languageCode = browserLang
    } else if (
      !isEmpty(profileCountryCode) &&
      Object.keys(countryLang).includes(profileCountryCode.toLowerCase())
    ) {
      languageCode = countryLang[profileCountryCode.toLowerCase()]
    } else {
      languageCode = fallbackLng
    }
    if (!i18next?.isInitialized) {
      i18next
        .use(LanguageDetector)
        .use(initReactI18next)
        .use(Backend)
        .init({
          debug,
          resources,
          react: {
            bindI18n: 'loaded languageChanged',
            bindI18nStore: 'added',
            useSuspense: true
          },
          detection: {
            order: ['queryString', 'cookie'],
            cache: ['cookie']
          },
          interpolation: {
            escapeValue: false
          },
          missingKeyHandler: (lng, ns, key, fallbackValue) => {
            console.warn(lng, ns, key, fallbackValue)
          }
        })
    }

    i18next?.changeLanguage(languageCode)

    yield put(
      translationActions.translationRequestSuccess({ languageCode, resources })
    )
  } catch (e) {
    console.error(e)
    yield put(translationActions.translationRequestFail())
  }
}

export default function* watchTranslationRequest(services) {
  yield all([
    takeEvery(bootstrapActions.requestBootstrap, translationRequest, services)
  ])
}
